import { isObject } from '../../shared/is-object';
import { readJSONFile } from '../../shared/read-json-file';
import type { APIAnnotationData } from '../../types/api';
import type { JSONExportContent } from '../services/annotations-exporter';

/**
 * Parse a file generated by the annotation exporter and return the extracted
 * annotations.
 */
export async function readExportFile(file: File): Promise<APIAnnotationData[]> {
  let json;
  try {
    json = await readJSONFile(file);
  } catch {
    throw new Error('Not a valid JSON file');
  }

  // Perform some very rudimentary validation of the file content, just enough
  // to catch issues where the user picked the wrong kind of JSON file.
  if (!isObject(json) || !Array.isArray((json as any).annotations)) {
    throw new Error('Not a valid Hypothesis JSON file');
  }

  return (json as JSONExportContent).annotations;
}
